import { ModelsUploadView } from "../_components";

export default function ContentModelsUploadPage() {
  return <ModelsUploadView />;
}
